var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcListCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09766 11.1839L5.1644 14.4672C5.26584 14.599 5.39583 14.7062 5.54459 14.7805C5.69335 14.8549 5.85703 14.8946 6.02334 14.8967C6.18697 14.8986 6.34896 14.864 6.49754 14.7954C6.64612 14.7268 6.77755 14.626 6.88227 14.5003L13.9042 6.10547",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcListCheck);
export default __webpack_public_path__ + "static/media/ic_list_check.982f93a0bc9fb146b12e1b2ca6ef4d6d.svg";
export { ForwardRef as ReactComponent };